import axios from "./axios_interceptor";
import {get_jwt_token, loginRedirect} from './helper_funtions'

// Generic function to get branding configuration
const getBrandingConfig = async (name, requireAuth = true) => {
  const url = `/branding/customer-logo-configuration/?name=${name}`;
  try {
    const config = {};
    if (requireAuth) {
      const token = get_jwt_token();
      config.headers = {
        Authorization: `Bearer ${token}`,
      };
    }
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e?.response?.data?.errors || `Failed to load ${name}` };
  }
};

// Logo APIs
export const getBrandingLogo = async () => {
  return getBrandingConfig('logo', true);
};

export const getBrandingLogoForgotPassword = async () => {
  return getBrandingConfig('logo', false);
};

export const setBrandingLogo = async (formField) => {
  const url = "/branding/";
  try {
    const token = get_jwt_token();
    loginRedirect(token);
        const config = {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${token}`
            },
        };
    const response = await axios.post(url, formField, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

// Favicon APIs
export const getBrandingFavicon = async () => {
  return getBrandingConfig('favicon', true);
};

export const getBrandingFaviconForgotPassword = async () => {
  return getBrandingConfig('favicon', false);
};

export const setBrandingFavicon = async (formField) => {
  const url = "/branding/";
  try {
    const token = get_jwt_token();
    loginRedirect(token);
        const config = {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${token}`
            },
        };
    const response = await axios.post(url, formField, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const getOrganisationDomain = async () => {
  const url = "/customer/organisation-name/";
  try {
    const token = get_jwt_token();
    loginRedirect(token);
        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        };
    const response = await axios.get(url, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};

export const setOrganisationDomain = async (formField) => {
  const url = "/customer/organisation-name/";
  try {
    const token = get_jwt_token();
    loginRedirect(token);
        const config = {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        };
    const response = await axios.post(url, formField, config);
    return { data: response.data, error: null };
  } catch (e) {
    return { data: null, error: e.response?.data?.errors || e.message || "An error occurred" };
  }
};